import {
  collection,
  doc,
  getDoc,
  getDocs,
  query,
  where,
} from 'firebase/firestore';
import { createTechnicalTicket } from './technicalTicketMessages';
import { getTicketLastActivityMs } from './technicalConversation';

const TECHNICAL_TICKETS_COLLECTION = 'assistenzatecnica';

export function getTechnicalTicketLastUpdate(ticket = {}) {
  return getTicketLastActivityMs(ticket);
}

export function pickCanonicalTechnicalTicket(tickets = []) {
  const normalizedTickets = tickets.filter((ticket) => ticket?.id);
  if (!normalizedTickets.length) return null;

  return normalizedTickets.slice().sort((a, b) => {
    const aOpen = a.status !== 'Completato';
    const bOpen = b.status !== 'Completato';
    if (aOpen !== bOpen) return aOpen ? -1 : 1;

    const latestDiff =
      getTechnicalTicketLastUpdate(b) - getTechnicalTicketLastUpdate(a);
    if (latestDiff !== 0) return latestDiff;

    return String(a.id).localeCompare(String(b.id));
  })[0];
}

export async function resolveUserTechnicalTicket(db, userId) {
  if (!db || !userId) return null;

  const ticketsById = new Map();
  const directSnap = await getDoc(doc(db, TECHNICAL_TICKETS_COLLECTION, userId));
  if (directSnap.exists()) {
    const directData = directSnap.data() || {};
    if (!directData.userId || directData.userId === userId) {
      ticketsById.set(directSnap.id, {
        id: directSnap.id,
        ...directData,
      });
    }
  }

  const ticketsSnapshot = await getDocs(
    query(
      collection(db, TECHNICAL_TICKETS_COLLECTION),
      where('userId', '==', userId)
    )
  );

  ticketsSnapshot.forEach((ticketSnap) => {
    ticketsById.set(ticketSnap.id, {
      id: ticketSnap.id,
      ...(ticketSnap.data() || {}),
    });
  });

  return pickCanonicalTechnicalTicket(Array.from(ticketsById.values()));
}

export async function createUserTechnicalTicket(db, { userId, title = '', description = '' } = {}) {
  if (!db || !userId) {
    throw new Error('Utente non autenticato.');
  }

  const existingTicket = await resolveUserTechnicalTicket(db, userId);
  if (existingTicket?.id) {
    return { ticketId: existingTicket.id, created: false };
  }

  const cleanDescription = String(description || '').trim();
  if (!cleanDescription) {
    throw new Error('Descrizione obbligatoria.');
  }

  return createTechnicalTicket({ userId, title, content: cleanDescription });
}
